/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskReturnData } from './ExecRiskReturnData';
import {
    ExecRiskReturnDataFromJSON,
    ExecRiskReturnDataFromJSONTyped,
    ExecRiskReturnDataToJSON,
} from './ExecRiskReturnData';
import type { ExecRiskReturnHeader } from './ExecRiskReturnHeader';
import {
    ExecRiskReturnHeaderFromJSON,
    ExecRiskReturnHeaderFromJSONTyped,
    ExecRiskReturnHeaderToJSON,
} from './ExecRiskReturnHeader';

/**
 * 
 * @export
 * @interface ExecRiskForm990
 */
export interface ExecRiskForm990 {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990
     */
    irs_object_id: string;
    /**
     * 
     * @type {ExecRiskReturnHeader}
     * @memberof ExecRiskForm990
     */
    ReturnHeader: ExecRiskReturnHeader;
    /**
     * 
     * @type {ExecRiskReturnData}
     * @memberof ExecRiskForm990
     */
    ReturnData: ExecRiskReturnData;
}

/**
 * Check if a given object implements the ExecRiskForm990 interface.
 */
export function instanceOfExecRiskForm990(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "irs_object_id" in value;
    isInstance = isInstance && "ReturnHeader" in value;
    isInstance = isInstance && "ReturnData" in value;

    return isInstance;
}

export function ExecRiskForm990FromJSON(json: any): ExecRiskForm990 {
    return ExecRiskForm990FromJSONTyped(json, false);
}

export function ExecRiskForm990FromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForm990 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'irs_object_id': json['irs_object_id'],
        'ReturnHeader': ExecRiskReturnHeaderFromJSON(json['ReturnHeader']),
        'ReturnData': ExecRiskReturnDataFromJSON(json['ReturnData']),
    };
}

export function ExecRiskForm990ToJSON(value?: ExecRiskForm990 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'irs_object_id': value.irs_object_id,
        'ReturnHeader': ExecRiskReturnHeaderToJSON(value.ReturnHeader),
        'ReturnData': ExecRiskReturnDataToJSON(value.ReturnData),
    };
}

